import React, { FC, useMemo } from "react";
import cn from "clsx";
import ReactHtmlParser from "react-html-parser";
import isEmpty from "lodash/isEmpty";
import { ProductSizeFormatMessagesProps } from "./types";

const ProductSizeFormatMessages: FC<ProductSizeFormatMessagesProps> = ({
  productHighlights,
  containerClassName,
  clickHandlers,
  withNoBorder
}) => {
  const productSizeFormatMessage = useMemo(() => {
    return productHighlights?.sizeShown;
  }, [productHighlights]);

  if (isEmpty(productSizeFormatMessage)) return null;

  const { values } = productSizeFormatMessage;

  return (
    <>
      {values?.map(
        (messageItem: { icon: string; text: string }, index: number) => (
          <div className={cn(containerClassName)} key={index}>
            <div
              className={cn("size-spec", {
                with_no_border: withNoBorder
              })}
            >
              <div>
                <img
                  src={messageItem.icon}
                  alt="size helper text"
                  className="ruler-icon"
                />
              </div>
              <div onClick={clickHandlers?.[index]}>
                {ReactHtmlParser(messageItem.text)}
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
};

export default ProductSizeFormatMessages;
